// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"52661d75","202":"03dcae2a","366":"47080aa8","484":"2768423c","489":"cdcaf760","625":"1d1a1228","734":"5b34c148","761":"5450919c","784":"39e45811","895":"89bd4396","990":"86b1c8df"}[chunkId] + ".chunk.js";
};